import { domMax, LazyMotion } from "motion/react"
import type { ReactNode } from "react"

/**
 * Motion's features, loaded once for the whole tree. Components use `m.*`
 * from "motion/react-m" instead of `motion.*`, so only this feature set is
 * bundled. domMax (animations, exit, hover/tap, drag, layout) rather than
 * domAnimation: the data room rows animate with `layout="position"`, which
 * domAnimation would silently ignore. `strict` throws on a stray `motion.*`,
 * which would bring the full set back regardless.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return (
    <LazyMotion features={domMax} strict>
      {children}
    </LazyMotion>
  )
}
